import { Theme, alpha } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    btn: {
      borderRadius: '999em',
      lineHeight: 1,
      fontWeight: 'bold',
      boxShadow: `0px 3px 6px ${colorsPalette.black}`,
      textDecoration: 'none',
      fontSize: 16,
    },
    btnContained: {
      border: 'none',
      padding: '19px 35px',
      [theme.breakpoints.up('md')]: {
        padding: '15px 32px',
      },
    },
    btnContainedSecondary: {
      background: colorsPalette.blue,
      '&:hover': {
        background: alpha(colorsPalette.blue, 0.8),
      },
    },
    btnDisabled: {},
  }),
);

export default useStyles;
